




























import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class SzsxCompleteDialog extends Vue {
  @Prop()
  private ifVisible: any;
  @Prop()
  private result;
  private get visible() {
    return this.ifVisible;
  }
  private set visible(val) {
    this.$emit("update:ifVisible", val);
  }
  private jumpResult() {
    this.$router.replace({
      path: "/main/szjx/szsx-moni-result",
      query: {
        id: this.result.moni_id,
      },
    });
  }
  private jumpList() {
    this.$router.replace({
      path: "/main/szjx/szsx",
    });
  }
}
